import React from 'react';
import { ApolloClient, InMemoryCache, createHttpLink, ApolloProvider } from '@apollo/client';
import PlanBuilderOverviewReport from '../../components/Reports/PlanBuilderOverviewReport';

const httpLink = createHttpLink({
  uri: '/graphql',
  credentials: 'same-origin',
  headers: { 'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content }
});

const client = new ApolloClient({ link: httpLink, cache: new InMemoryCache() });

const PlanBuilderOverviewReportContainer = (props) => (
  <ApolloProvider client={client}>
    <PlanBuilderOverviewReport {...props} />
  </ApolloProvider>
);

export default PlanBuilderOverviewReportContainer;



